/* eslint-disable no-param-reassign */
import { z } from 'zod'

const validateEmailList = (list: Array<string>) => {
  const emailList = z.array(z.string().email())
  list = list.map(email => email.trim())
  list = list.filter((x, i, a) => a.indexOf(x) === i)
  const zod = emailList.safeParse(list)
  return {
    list: zod.success ? list : [],
    success: zod.success,
  }
}

export default validateEmailList
